import { SocialMedia } from './SocialMedia';

export type { TypeSocialMediaProps } from './types';
export default SocialMedia;
